<template>
  <div class="column padding-bottom-0" :data-track="dataTrack" @click="focusOutFilter">
    <div v-if="item.name === 'date'" :class="{'padding-right-0':index === filter_items.length-1}"
         v-for="(item, index) in filter_items">
      <div :class="[{'is-active': isDropdownActive}, 'dropdown']" @click="focusOutFilter">
        <div class="dropdown-trigger">
          <button :data-track="item.dataTrack" class="button button-dropdown" aria-haspopup="true"
                  aria-controls="dropdown-menu">
            <img src="/static/img/calender_icon.svg"/>
            <span class="is-size-7" :id="`selected${item.label}`" :ref="`selected${item.label}`">{{getDefaultAllTimeDateRange()}}</span>
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </button>
        </div>

        <div class="dropdown-menu padding-top-0 padding-bottom-0" role="menu">
          <div class="dropdown-content is-marginless is-paddingless" :style="styleProp">
            <div v-for="(element, index) in item.elements">
              <div
                class="columns is-mobile is-paddingless is-marginless border-bottom-dbdbdb dropdown-option"
                :class="[{'is-custom-element': element === 'Custom'}]">
                <div class="column is-12 is-paddingless">
                  <div class="datepicker-trigger">
                    <label
                      :class="['radio  label-filters', {'is-select-active': element === date, 'disabled-text': isDisabled(element)}]"
                      ref="airbnb_datepicker" @click="setDateFilterLabel(element, true)">
                      {{ element }}<i>{{ isDisabled(element) ? ' (Upgrade to gain access)' : ''}}</i>
                      <input type="radio"
                             :value="element"
                             :name="`${item.name}`"
                             v-model="date"
                             :id="String(index)"
                      />
                    </label>
                    <!-- Start Datepicker code -->
                    <div v-if="isCalenderVisible" class="is-hidden-touch is-desktop-active">
                      <AirbnbStyleDatepicker
                        :trigger-element-id="String(index)"
                        :mode="'range'"
                        :fullscreen-mobile="false"
                        :date-one="filter_date_from"
                        :date-two="filter_date_to"
                        @date-one-selected="val => { filter_date_from = val }"
                        @date-two-selected="val => { filter_date_to = val }"
                        :end-date="currentDate"
                        :show-action-buttons="false"
                        :show-shortcuts-menu-trigger="false"
                      >
                        <template slot="previous-month-icon">
                          <div class="field" @click="handleDefaultClick" @change="handleDefaultClick">
                            <div class="control">
                              <img src="/static/img/calender_icon.svg"/>
                              <input type="text" v-model="enteredStartDate">
                              <span v-if="startDateError" class="date-error-msg">{{startDateError}}</span>
                            </div>
                          </div>
                          <i class="fa fa-angle-left"></i>
                        </template>
                        <template slot="next-month-icon">
                          <div class="field" @click="handleDefaultClick" @change="handleDefaultClick">
                            <div class="control">
                              <img src="/static/img/calender_icon.svg"/>
                              <input type="text" v-model="enteredEndDate">
                              <span v-if="endDateError" class="date-error-msg">{{endDateError}}</span>
                            </div>
                          </div>
                          <i class="fa fa-angle-right"></i>
                        </template>
                      </AirbnbStyleDatepicker>
                    </div>
                    <div class="is-tablet-active" v-if="isCalenderVisible">
                      <AirbnbStyleDatepicker
                        :trigger-element-id="String(index)"
                        :mode="'range'"
                        :fullscreen-mobile="false"
                        :date-one="filter_date_from"
                        :date-two="filter_date_to"
                        @date-one-selected="val => { filter_date_from = val }"
                        @date-two-selected="val => { filter_date_to = val }"
                        :end-date="currentDate"
                        :show-action-buttons="false"
                        :show-shortcuts-menu-trigger="false"
                      >
                        <template slot="previous-month-icon">
                          <i class="fa fa-angle-left"></i>
                        </template>
                        <template slot="next-month-icon">
                          <div class="field" @click="handleDefaultClick" @change="handleDefaultClick">
                            <div class="control">
                              <img src="/static/img/calender_icon.svg"/>
                              <input type="text" v-model="formattedStartDate">
                            </div>
                          </div>
                          <i class="fa fa-angle-right"></i>
                        </template>
                      </AirbnbStyleDatepicker>
                    </div>
                  </div>
                  <!-- End Datepicker code -->
                </div>
              </div>
            </div>
            <div v-if="!filter_items[0].default || filter_items[0].showApplyBtn">
              <div
                class="columns is-mobile is-paddingless is-marginless border-bottom-dbdbdb-last">
                <div class="column is-12 is-paddingless">
                  <div class="datepicker-trigger">
                    <button class="button is-button-blue is-button-medium has-button-medium-min-max-width"
                            @click="applyFilter">APPLY
                    </button>
                    <button
                      class="button is-button-blue-outline is-button-medium has-button-medium-min-max-width margin-right-10 cancel"
                      @click="cancelFilter">CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc */
  import misc from '../mixins/misc.js'
  import moment from 'moment'

  export default {
    name: 'date-select-filter',
    mixins: [misc],
    props: ['reviews_start_date', 'filter_items', 'dataTrack', 'contentHeight', 'styleProp'],
    data () {
      return {
        date: '',
        dateFormat: 'DD-MM-YYYY',
        filter_date_from: '',
        filter_date_to: '',
        uid: null,
        isCalenderVisible: false,
        startDateError: '',
        endDateError: '',
        enteredEndDate: '',
        enteredStartDate: '',
        isDropdownActive: false,
        selected: {startDate: '', endDate: ''}
      }
    },
    mounted () {
      this.uid = this._uid
    },
    created () {
      this.date = window.localStorage.hasOwnProperty('currentDateFilter') ? JSON.parse(window.localStorage.getItem('currentDateFilter')) : undefined
      /** If default filter/selected provided */
      if (this.filter_items[0].default) {
        this.date = this.filter_items[0].default.selected
        const startEndDate = this.calcStartEndDate(this.date)
        Object.assign(this.selected, {
          endDate: startEndDate.endDate.format('YYYY-MM-DD'),
          startDate: startEndDate.startDate.format('YYYY-MM-DD')
        })

        this.$emit('onDateChange', {
          label: this.date.split(' ').join('_').toLowerCase(),
          text: this.date.toLowerCase(),
          endDate: this.selected.endDate,
          startDate: this.selected.startDate
        })
      }
      if (this.date === 'Custom') {
        let dates = window.localStorage.hasOwnProperty('reviewsDateFilter') ? JSON.parse(window.localStorage.getItem('reviewsDateFilter')) : ''
        let datesArr = dates ? dates.split('-') : []
        this.filter_date_to = datesArr.length > 0 ? moment(datesArr[1].trim()).format('YYYY-MM-DD') : ''
        this.filter_date_from = datesArr.length > 0 ? moment(datesArr[0].trim()).format('YYYY-MM-DD') : ''
        if (this.filter_date_from && this.filter_date_to) {
          this.$emit('selected-dates', {startDate: this.filter_date_from, endDate: this.filter_date_to})
        }
      }
    },
    computed: {
      /**
       * Return current date
       *
       * @returns {string}
       */
      currentDate () {
        return moment().format('YYYY-MM-DD')
      },
      /**
       * return selected dates
       *
       * @returns {string}
       */
      getCustomDates () {
        return this.filter_date_from && this.filter_date_to ? `${moment(this.filter_date_from).format('DD MMM YYYY')} - ${moment(this.filter_date_to).format('DD MMM YYYY')}` : ''
      },
      /**
       * Return formatted start date
       *
       * @returns {string}
       */
      formattedStartDate () {
        return this.filter_date_from ? moment(this.filter_date_from).format('DD-MM-YYYY') : this.filter_date_from
      },
      /**
       * Return formatted end date
       *
       * @returns {string}
       */
      formattedEndDate () {
        return this.filter_date_to ? moment(this.filter_date_to).format('DD-MM-YYYY') : this.filter_date_to
      }
    },
    methods: {
      /**
       * Function to apply filter
       *
       * @returns {void}
       * @param {event} event to handle after apply button click
       */
      applyFilter (event) {
        let todayDate = moment().format('DD-MM-YYYY').split('-')
        if (this.enteredStartDate) {
          let startDate = this.enteredStartDate.split('-')
          this.enteredStartDate = (new Date(startDate[2], startDate[1], startDate[0]).getTime() < new Date(todayDate[2], todayDate[1], todayDate[0]).getTime()) ? this.enteredStartDate : moment().format('DD-MM-YYYY')
          if (startDate.length === 3 && startDate[2].length === 4 && startDate[1] > 12) {
            this.startDateError = 'Invalid entered date'
          } else if (startDate.length === 3 && startDate[2].length === 4 && startDate[1] < 13) {
            this.startDateError = ''
            startDate = this.enteredStartDate.split('-')
            this.filter_date_from = moment([startDate[2], startDate[1], startDate[0]].join('-')).format('YYYY-MM-DD')
          } else {
            this.startDateError = 'Invalid entered date'
          }
        }
        if (this.enteredEndDate) {
          let endDate = this.enteredEndDate.split('-')
          this.enteredEndDate = (new Date(endDate[2], endDate[1], endDate[0]).getTime() < new Date(todayDate[2], todayDate[1], todayDate[0]).getTime()) ? this.enteredEndDate : moment().format('DD-MM-YYYY')
          if (endDate.length === 3 && endDate[2].length === 4 && endDate[1] > 12) {
            this.endDateError = 'Invalid entered date'
          } else if (endDate.length === 3 && endDate[2].length === 4 && endDate[1] < 13) {
            this.endDateError = ''
            endDate = this.enteredEndDate.split('-')
            this.filter_date_to = moment([endDate[2], endDate[1], endDate[0]].join('-')).format('YYYY-MM-DD')
          } else {
            this.endDateError = 'Invalid entered date'
          }
        }
        if (!this.startDateError && !this.endDateError) {
          if (this.filter_date_to && this.filter_date_from) {
            event.stopPropagation()
            this.isDropdownActive = false
            this.$emit('selected-dates', {startDate: this.filter_date_from, endDate: this.filter_date_to})
            this.$emit('onDateChange', {
              label: this.date.split(' ').join('_').toLowerCase(),
              text: this.date.toLowerCase(),
              endDate: this.filter_date_to,
              startDate: this.filter_date_from
            })
          }
        }
      },
      /**
       * Handle cancel filter event
       *
       * @param {event} event to handle cancel event
       * @returns {void}
       */
      cancelFilter (event) {
        event.stopPropagation()
        this.isDropdownActive = false
      },
      /**
       * Function to fire event when focus on filter
       *
       * @param {event} event to handle filter on focus
       * @returns {void}
       */
      focusOutFilter (event) {
        event.stopPropagation()
        this.isDropdownActive = this.date !== 'Custom' ? !this.isDropdownActive : true
      },
      /**
       * Select default dates for default filter
       *
       * @returns {string|any}
       */
      getDefaultAllTimeDateRange () {
        let dateTo = moment().format('DD MMM YYYY')
        let dateFrom = moment().format('DD MMM YYYY')
        /** Show default selected date in dropdown */
        if (this.date !== 'All time' && this.filter_items[0].default) {
          return moment(this.selected.startDate).format('DD MMM YYYY') + ' - ' + moment(this.selected.endDate).format('DD MMM YYYY')
        }
        if (this.reviews_start_date && typeof (this.reviews_start_date) !== 'undefined') {
          dateFrom = moment(this.reviews_start_date).format('DD MMM YYYY')
        }
        if (this.date !== 'All time' && window.localStorage.hasOwnProperty('reviewsDateFilter')) {
          return JSON.parse(window.localStorage.getItem('reviewsDateFilter'))
        }
        return `${dateFrom} - ${dateTo}`
      },
      /**
       * Function to set selected filters
       *
       * @param {date} date that need to be filled in filter
       * @returns {void}
       */
      setDateFilterLabel (date, isDirectClicked = false) {
        if (this.date === date && isDirectClicked) {
          return false
        }
        /** If selected option is disabled, then return */
        if (this.isDisabled(date)) {
          this.$router.push('/billing/edit-plan/g1/monthly')
        }
        this.date = date
        let label = ''
        this.isCalenderVisible = false
        if (this.date) {
          label = this.date

          if (this.date === 'Custom') {
            this.isCalenderVisible = true
            label = this.getCustomDates
          } else {
            const startEndDate = this.calcStartEndDate(this.date)
            let dateTo = startEndDate.endDate.format('DD MMM YYYY')
            let dateFrom = startEndDate.startDate.format('DD MMM YYYY')

            if (this.date === 'Today') {
              label = dateTo
            } else if (this.date === 'All time') {
              this.selected.startDate = dateFrom
              label = `${dateFrom} - ${dateTo}`
            } else {
              this.selected.endDate = dateTo
              this.selected.startDate = dateFrom
              label = `${dateFrom} - ${dateTo}`
            }
          }
        } else {
          label = this.getDefaultAllTimeDateRange()
        }
        this.$refs.selectedDate[0].innerHTML = label
        window.localStorage.setItem('reviewsDateFilter', JSON.stringify(label))
        if (this.date !== undefined) {
          window.localStorage.setItem('currentDateFilter', JSON.stringify(this.date))
        }
        if (this.date !== 'Custom') {
          this.filter_date_to = this.enteredEndDate = ''
          this.filter_date_from = this.enteredStartDate = ''
          this.$emit('selected-dates', {startDate: '', endDate: ''})
          this.$emit('onDateChange', {
            label: this.date.split(' ').join('_').toLowerCase(),
            text: this.date.toLowerCase(),
            endDate: moment(this.selected.endDate).format('YYYY-MM-DD'),
            startDate: moment(this.selected.startDate).format('YYYY-MM-DD')
          })
        }
      },
      /**
       * Function to calculate start and end date as per given label
       *
       * @param {string}
       * @returns {object}
       */
      calcStartEndDate (label) {
        let dateTo = moment()
        let dateFrom = moment()
        if (label === 'Last 7 days') {
          dateTo.subtract(1, 'd')
          dateFrom.subtract(7, 'd')
        } else if (label === 'Previous month') {
          dateTo.subtract(1, 'months').endOf('month')
          dateFrom.subtract(1, 'months').date(1)
        } else if (label === 'Last 6 months') {
          dateTo.subtract(1, 'months').endOf('month')
          dateFrom.subtract(6, 'months').date(1)
        } else if (label === 'Last 12 months') {
          dateTo.subtract(1, 'months').endOf('month')
          dateFrom.subtract(12, 'months').date(1)
        } else if (label === 'Previous calendar year') {
          dateTo.subtract(1, 'year').endOf('year')
          dateFrom.subtract(1, 'year').startOf('year')
        } else if (label === 'Month to date') {
          dateFrom.date(1)
        } else if (this.date === 'All time') {
          if (this.reviews_start_date && typeof (this.reviews_start_date) !== 'undefined') {
            dateFrom = moment(this.reviews_start_date)
          }
        } else {
          const option = this.date.split(' ')
          if (option.length === 2 && ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].includes(option[0]) && option[1].length === 4) {
            dateFrom = moment(this.date, 'MMMM YYYY').startOf('month')
            dateTo = moment(this.date, 'MMMM YYYY').endOf('month')
          }
        }
        return {startDate: dateFrom, endDate: dateTo}
      },
      /**
       * Handle default click
       *
       * @param {event} event to handle default click
       * @returns {void}
       */
      handleDefaultClick (event) {
        event.stopPropagation()
      },
      /**
       * Check if the field is disabled
       * @params {string} option
       * @returns {boolean/void}
       */
      isDisabled (option) {
        if (this.filter_items[0].disabled) {
          return this.filter_items[0].disabled.includes(option)
        }
      }
    },
    watch: {
      'filter_date_from': function (val) {
        if (val) {
          this.enteredStartDate = this.formattedStartDate
          this.setDateFilterLabel('Custom')
        }
      },
      'filter_date_to': function (val) {
        if (val) {
          this.enteredEndDate = this.formattedEndDate
          this.setDateFilterLabel('Custom')
        }
      },
      'date': function (newVal, oldVal) {
        if (this.filter_items[0].disabled && this.filter_items[0].disabled.includes(newVal)) {
          this.date = oldVal
        }
      }
    }
  }
</script>

<style scoped>
  .button.button-dropdown #selectedDate {
    min-height: 17px;
  }

  .tabs.is-toggle a {
    border-radius: 0;
    border: 0;
    padding: 10px 10px 11px 4px;
  }

  .tabs-open {
    padding: 10px 10px 24px 4px !important;
  }

  .tabs.is-boxed {
    background-color: #f5f5f5;
    border: 0 !important;
  }

  .search-filter-cont {
    background-color: #f5f5f5;
  }

  @media screen and (max-width: 767px) {
    .search-filter-cont {
      margin-top: 32px;
    }
  }

  .fa-filter {
    font-size: 1.2em;
  }

  label {
    color: #8a8c91;
    padding: .9em;
  }

  .fa-angle-down:before {
    border: 1px solid #95979b;
    border-right: 0;
    border-top: 0;
    content: " ";
    display: block;
    height: 0.5em;
    pointer-events: none;
    position: absolute;
    transform: rotate(-45deg);
    transform-origin: center;
    width: 0.5em;
    margin-top: -0.375em;
    right: 1.125em;
    top: 50%;
    z-index: 4;
  }

  .dropdown-trigger {
    text-align: left;
    width: 100%;
  }

  .dropdown {
    width: 100%;
  }

  .fa-angle-down {
    font-size: 1.4rem;
  }

  .fa-angle-down:before {
    right: 0.7em;
  }

  .label-filters {
    color: #58595b;
  }

  .dropdown-menu {
    border-top: 3px solid #30AAE1;
    width: 100%;
  }

  .dropdown-content {
    border-radius: 0;
  }

  .border-bottom-dbdbdb {
    border-bottom: 1px solid #dbdbdb;
  }

  .is-size-6 {
    font-size: 0.9rem !important;
  }

  .column label.radio {
    display: block;
    padding-left: 0 !important;
    margin-left: 16px;
  }

  .radio input {
    opacity: 0 !important;

  }

  .is-select-active {
    color: #30aae1;
  }

  .field.is-grouped .control {
    font-size: 0.75rem;
  }

  .button.button-dropdown {
    padding-left: 12px !important;
  }

  .button.button-dropdown img {
    margin-right: 13px !important;
    padding: 10px 0px 10px 0px;
    position: absolute;
    height: 40px;
  }

  .button.button-dropdown span {
    margin-left: 43px !important;
  }

  .datepicker-trigger button {
    margin: 12.1px 3px;
  }

  .fa-angle-left {
    left: 26px;
    top: 51px;
    position: absolute;
  }

  .fa-angle-right {
    right: 24px;
    top: 51px;
    position: absolute;
  }

  .asd__datepicker-header i {
    color: #7e7e7e;
    font-size: 22px;
  }

  .date-error-msg {
    color: #f07a98;
    display: block;
    font-size: 10px;
  }

  input::placeholder {
    color: #58595b !important;
  }

  ::-webkit-input-placeholder { /* Edge */
    color: #58595b !important;
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #58595b !important;
  }

  .disabled-text {
    color: #707070;
    opacity: 0.5;
  }
</style>
<style>
  .has-button-medium-min-max-width {
    min-width: 42% !important;
    max-width: 42% !important;
  }

  .asd__day.asd__day--enabled.asd__day--selected.asd__selected-date-two button.asd__day-button, td.asd__day.asd__day--enabled.asd__day--selected.asd__selected-date-one button.asd__day-button {
    background-color: #30aae1 !important;
    border-radius: 50% !important;
    width: 25px;
    height: 25px;
  }

  td.asd__day--disabled > button {
    text-decoration: line-through !important;
  }

  td.asd__day--enabled {
    border: none;
  }

  td.asd__day.asd__day--enabled.asd__day--selected.asd__selected-date-two, td.asd__day.asd__day--enabled.asd__day--selected.asd__selected-date-one {
    background: transparent !important;
    border: 0px !important;
  }

  td.asd__day.asd__day--enabled.asd__day--selected.asd__selected-date-one {
    background-image: linear-gradient(to left, rgb(202, 232, 245) 40%, transparent) !important;
  }

  .asd__change-month-button > button {
    border: none !important;
    padding: 0px 5px 0px 7px !important;
  }

  .asd__day.asd__day--enabled.asd__day--hovered {
    width: 125px;
    height: 24px;
    background-color: #30aae1 !important;
    border-radius: 50% !important;
    border: none !important;
    color: #58595b !important;
  }

  td.asd__day.asd__day--enabled.asd__day--selected.asd__selected-date-two {
    background: transparent !IMPORTANT;
    border: 0px !important;
    background-image: linear-gradient(90deg, rgb(202, 232, 245) 50%, transparent) !important;
  }

  .asd__day.asd__day--enabled.asd__day--in-range {
    color: #58595b !important;
    background-color: rgb(202, 232, 245) !important;
    border: 1px solid rgb(202, 232, 245) !important;
  }

  .asd__days-legend {
    margin-top: 42px !important;
  }

  .asd__month-name {
    margin-top: 40px;
  }

  .asd__month-name span {
    width: 64px;
    height: 15px;
    font-size: 17px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    color: #58595b;
  }

  .asd__datepicker-header input {
    height: 36px !important;
    width: 262px !important;
    padding: 8px 19px 8px 43px;
    border-radius: 2px;
    border: solid 1px rgba(88, 89, 91, 0.32);
  }

  .asd__datepicker-header img {
    padding: 12px 8px 8px 13px;
    position: absolute;
    height: 38px;
    top: -3px;
  }

  .asd__wrapper.asd__wrapper--datepicker-open {
    width: 600px !important;
    z-index: 100 !important;
    top: -233px !important;
    left: -600px !important;
    height: 341px;
  }

  button.cancel {
    position: absolute;
    right: 0;
  }

  .asd__datepicker-header button:focus {
    border: none !important;
    outline: none !important;
  }

  .asd__day {
    line-height: 25px;
    height: 23px;
    overflow: hidden;
  }

  .label-filters {
    font-size: 0.8rem !important;
    padding: 0px !important;
  }

  .border-bottom-dbdbdb {
    border-bottom: 1px solid #dbdbdb;
    padding: 8px 10px !important;
  }

  .datepicker-trigger {
    margin: 0px 0px 0px 1px !important;
  }

  .has-button-medium-min-max-width {
    width: 114px !important;
    height: 32px !important;
    line-height: 2px !important;
  }

  .column label {
    margin-left: 0px !important;
  }

  /*.border-bottom-dbdbdb:nth-child(even) {*/
  /*  border-bottom: none !important;*/
  /*}*/

  .border-bottom-dbdbdb {
    border: 1px solid #dbdbdb;
    padding: 8px 10px !important;
    border-top: none;
  }

  .dropdown-content {
    box-shadow: none !important;
  }

  .asd__day-button {
    height: 28px;
    width: 25px;
  }

  /* For mobile phones: */
  @media (max-width: 768px) {

    .asd__change-month-button > button {
      position: absolute !important;
      left: -301px !important;
    }

    .asd__inner-wrapper {
      margin-left: 0px !important;
    }

    .asd__change-month-button--previous {
      left: 202px !important;
    }

    .fa-angle-left {
      left: 13px !important;
    }

    .is-tablet-active {
      position: absolute;
      left: 282px !important;
      bottom: 101px;
    }

    .asd__wrapper.asd__wrapper--datepicker-open {
      width: 290px !important;
      left: -277px !important;
      position: relative;
      top: -168px !important;
      height: 286px !important;
    }

    .asd__change-month-button {
      left: 312px !important;
    }

    .fa-angle-right {
      left: 11.3em !important;
    }

    .asd__month {
      position: absolute !important;
      left: 8px !important;
      padding: 15px 15px 12px 12px !important;
    }

    .asd__change-month-button--next {
      right: 1px !important;
      padding-right: 13px !important;
    }

    .border-bottom-dbdbdb-last {
      display: none !important;
    }

    .is-custom-element {
      display: none !important;
    }

    .dropdown-content.is-marginless.is-paddingless {
      height: auto;
    }
  }

  /* For tablets: */
  @media (min-width: 769px) and (max-width: 1023px) {
    .asd__inner-wrapper {
      margin-left: 0px !important;
    }

    .asd__change-month-button--previous {
      left: 202px !important;
    }

    .fa-angle-left {
      left: 122px !important;
    }

    .is-tablet-active {
      display: flex;
    }

    .is-desktop-active {
      display: none;
    }

    .datepicker-trigger {
      display: flex !important;
    }

    .datepicker-trigger > button {
      margin: 10px -2px !important;
    }

    .asd__wrapper.asd__wrapper--datepicker-open {
      width: 300px !important;
      left: -311px !important;
      z-index: 101 !important;
      height: 286px !important;
      top: -186px !important;
    }

    .fa-angle-left {
      left: 92px !important;
    }

    .fa-angle-right {
      right: 10px !important;
    }

    .asd__change-month-button > button {
      position: absolute !important;
      left: -272px !important;
    }

    div .asd__month:first-of-type {
      position: absolute !important;
      left: 333px !important;
    }

    .button.button-dropdown #selectedDate {
      margin-right: 15px !important;
      margin-left: 28px !important;
    }

    .border-bottom-dbdbdb-last {
      padding: 10px 7px 10px 9px !important;
      border: 1px solid #dbdbdb !important;
      border-top: none !important;
    }

    .border-bottom-dbdbdb:nth-last-child(6) {
      display: none !important;
    }
  }

  @media (min-width: 1024px) {
    .is-tablet-active {
      display: none;
    }

    .asd__wrapper.asd__wrapper--datepicker-open {
      width: 438px !important;
      left: -449px !important;
      height: 286px !important;
      top: -186px !important;
    }

    .asd__inner-wrapper .asd__month {
      width: 200px !important;
      margin-left: 62px !important;
    }

    .asd__inner-wrapper .asd__month:nth-of-type(2n-1) {
      margin-left: 6px !important;
    }

    .asd__inner-wrapper .asd__month.asd__month--hidden {
      margin-left: 52px !important;
    }

    .asd__days-legend {
      width: 200px !important;
      padding: 0px;
    }

    .asd__days-legend:nth-of-type(2n) {
      margin-left: -96px !important;
      left: 315px !important;
      text-align: left;
    }

    .asd__days-legend:nth-of-type(2n-1) {
      left: 10px !important;
    }

    .asd__datepicker-header input {
      width: 186px !important;
    }

    .asd__month-name span {
      font-size: 0.8em !important;
    }

    .asd__month-name span:nth-of-type(2n-1) {
      margin-left: 10px !important;
    }

    .field:not(:last-child) {
      margin-bottom: 0px !important;
    }

    .asd__day-title {
      text-align: right;
    }

    .border-bottom-dbdbdb-last {
      border: 1px solid #dbdbdb;
      padding: 8px 11px 8px 11px !important;
      border-top: none;
      background: #fff;
    }
  }

  td.asd__day.asd__day--enabled.asd__day--selected.asd__selected-date-one button.asd__day-button {
    height: 25px;
    width: 25px;
    font-size: 12px !important;
    line-height: 25px;
  }

  .asd__inner-wrapper .asd__month {
    padding: 15px 0px 12px 4px;
  }

</style>



// WEBPACK FOOTER //
// src/components/DateSelectFilter.vue